// src/components/store/NewsletterSection.tsx
"use client";

import NewsletterSectionRenderer from "./sections/newsletter";

export default function NewsletterSection(props: any) {
  return <NewsletterSectionRenderer {...props} />;
}
export * from "./sections/newsletter";
